export const absoluteToRelativeUrl = absoluteUrl =>
  absoluteUrl ? new URL(absoluteUrl).pathname : null

/**
 * Resolve a link url against an optional base url (origin).
 *
 * Used to make header links absolute when the header is rendered on a
 * reverse-proxied host (e.g. chat.auction.com proxying to www.auction.com).
 * Without this, root-relative links like "/" or "/apps/api/session-handoff?..."
 * resolve against the proxy host and 302 incorrectly (dropping query params).
 *
 * Only root-relative paths (starting with a single "/") are prefixed. External
 * urls (http/https, protocol-relative "//"), anchors ("#"), and empty/undefined
 * urls are returned unchanged. When baseUrl is falsy the url is returned as-is,
 * preserving existing relative-path behavior.
 *
 * @param {string} url - the link url (may be relative, absolute, or anchor)
 * @param {string} [baseUrl] - origin to prefix, e.g. "https://www.auction.com"
 * @returns {string} resolved url
 */
export const resolveUrl = (url, baseUrl) => {
  if (!baseUrl || !url) return url
  // Only prefix root-relative paths; leave protocol-relative "//host" alone.
  if (url.startsWith('/') && !url.startsWith('//')) {
    return `${baseUrl}${url}`
  }
  return url
}
